import React from 'react';
import * as Classes from '../common/classes';
import { ButtonToolbar } from '../button-toolbar/ButtonToolbar';
import { Button } from '../button/Button';
import classNames from 'classnames';

export function ColorMenu({
  onChange,
  value,
}: {
  onChange: (val?: string) => void;
  value?: string;
}) {
  const colors = [
    { id: '#cd5c5c', name: 'indian red' },
    { id: '#dc143c', name: 'crimson' },
    { id: '#8b0000', name: 'dark red' },
    { id: '#c71585', name: 'medium violet red' },
    { id: '#ff6347', name: 'tomato' },
    { id: '#ff4500', name: 'orange red' },
    { id: '#ffd700', name: 'gold' },
    { id: '#bdb76b', name: 'dark khaki' },
    { id: '#ff00ff', name: 'magenta' },
    { id: '#ba55d3', name: 'medium orchid' },
    { id: '#8a2be2', name: 'blue violet' },
    { id: '#4b0082', name: 'indigo' },
    { id: '#483d8b', name: 'dark slate blue' },
    { id: '#006400', name: 'dark green' },
    { id: '#808000', name: 'olive' },
    { id: '#20b2aa', name: 'light sea green' },
    { id: '#008080', name: 'teal' },
    { id: '#4682b4', name: 'steel blue' },
    { id: '#4169e1', name: 'royal blue' },
    { id: '#000080', name: 'navy' },
    { id: '#daa520', name: 'goldenrod' },
    { id: '#874312', name: 'saddle brown' },
    { id: '#800000', name: 'maroon' },
    { id: '#708090', name: 'slate gray' },
    { id: '#000000', name: 'black' },
  ];

  return (
    <div className={Classes.COLOR_MENU}>
      <div className={Classes.COLOR_MENU_GRID}>
        {colors.map((color) => (
          <button
            key={color.id}
            onClick={() => onChange(color.id)}
            className={classNames(Classes.COLOR_BUTTON, {
              [Classes.COLOR_BUTTON_ACTIVE]: value === color.id,
            })}
            style={{ backgroundColor: color.id }}
          />
        ))}
      </div>
      <ButtonToolbar className="mt-1">
        <Button
          style="link"
          disableStopPropagation
          onClick={() => onChange(undefined)}
          className={Classes.SET_COLOR_BUTTON_NULL}
        >
          Bez barvy
        </Button>
      </ButtonToolbar>
    </div>
  );
}
